export default "__VITE_ASSET__BZVxro$l__"